module.exports = __webpack_public_path__ + "media/images/site/semi_aprovados-e2f9d9b556ab5aab0391c5ec74879315.jpg";